import { render, staticRenderFns } from "./names.vue?vue&type=template&id=defcd082&scoped=true"
import script from "./names.vue?vue&type=script&lang=js"
export * from "./names.vue?vue&type=script&lang=js"
import style0 from "./names.vue?vue&type=style&index=0&id=defcd082&prod&lang=scss"
import style1 from "./names.vue?vue&type=style&index=1&id=defcd082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defcd082",
  null
  
)

export default component.exports